export default defineI18nConfig(() => ({
    strategy: 'prefix',
    lazy: false,
    detectBrowserLanguage: false,
    locale: 'en',
    defaultLocale: "en",
    fallbackLocale: "en"
}));
